/**
 * Alberta stays on UTC-6 permanently from 2026-11-01 (tzdata 2026c). Runtimes and
 * devices with older time-zone data still fall back to UTC-7 that night, so any
 * Mountain-time conversion on or after the change uses the fixed offset instead of
 * trusting the runtime's rules. Before it, the runtime's America/Edmonton is correct.
 */
export const MOUNTAIN_ZONE = 'America/Edmonton'
const HOUR_MS = 3600_000
/** 2026-11-01 02:00 MDT, when the old rules would have fallen back. */
export const PERMANENT_UTC6_FROM = Date.UTC(2026, 10, 1, 8)
/** Wall-clock times on or after this calendar date are always UTC-6. */
export const PERMANENT_UTC6_WALL_FROM = Date.UTC(2026, 10, 1)

type Options = Omit<Intl.DateTimeFormatOptions, 'timeZone'>

/** A formatter that renders Mountain time correctly on either side of the change. */
export function mountainFormatter(locale: string, options: Options) {
  const zoned = new Intl.DateTimeFormat(locale, { ...options, timeZone: MOUNTAIN_ZONE })
  const fixed = new Intl.DateTimeFormat(locale, { ...options, timeZone: 'UTC' })
  return {
    format(date: Date): string {
      const ms = date.getTime()
      return ms >= PERMANENT_UTC6_FROM
        ? fixed.format(new Date(ms - 6 * HOUR_MS))
        : zoned.format(date)
    },
  }
}
